import styled from 'styled-components'

export const Description = styled.div`
  width: 100%;
  direction: rtl;
`
